import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-white mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-2">
        <div className="text-center text-xs text-gray-500">
          <p>&copy; 2025 One Pager. Built for creating and sharing one-pagers for building with LLMs.</p>
        </div>
      </div>
    </footer>
  );
};